import { DiscordContent } from "./Content";
import { Trans } from "@lingui/react/macro";
import {
  Card,
  CardContent,
  CardHeader,
  Heading,
} from "@wootingkb/component-library";

export default function Discord() {
  return (
    <Card>
      <CardHeader>
        <Heading as="h3" size="h4" weight="semibold">
          <Trans id="Discord_section_title">Discord</Trans>
        </Heading>
      </CardHeader>

      <CardContent className="flex flex-col gap-4">
        <DiscordContent />
      </CardContent>
    </Card>
  );
}
